import React from 'react';
import Hero from './components/career/Hero';
import Main from './components/career/Main';

const Career = () => {
    return (
        <div>
            <Hero />
            <Main />
        </div>
    )
}

export default Career;